import EFVideoModal from '@/components/UI/EFVideoModal';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import EcoVideo from 'eco-design/base/eco-video';
import { useRouter } from 'next/router';
import { useState } from 'react';
import css from './index.module.scss';

interface YoutubeMap {
    [key: string]: string;
}

export default function TheComp() {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('rapidseries');

    const [visible, setVisible] = useState(false);
    const [youtube, setYoutube] = useState<string>('');
    const youtubeMap: YoutubeMap = {
        us: 'https://www.youtube.com/embed/bb-qeO6u_9A?si=VlfevED0UfE5o4_p',
        ca: 'https://www.youtube.com/embed/bb-qeO6u_9A?si=VlfevED0UfE5o4_p',
        eu: 'https://www.youtube.com/embed/bb-qeO6u_9A?si=VlfevED0UfE5o4_p',
        uk: 'https://www.youtube.com/embed/bb-qeO6u_9A?si=VlfevED0UfE5o4_p',
        de: 'https://www.youtube.com/embed/bb-qeO6u_9A?si=-e2u80yYfYscQ0cP',
        fr: 'https://www.youtube.com/embed/NPn65Y4v7B0?si=jYsNZYOyc-5e4RaA',
        it: 'https://www.youtube.com/embed/znkA1SZvXiE?si=fHV_euAwAXXSSzL2',
        es: 'https://www.youtube.com/embed/oVSJrvsuHYM?si=UGR24OzBf5_KrhSD',
        jp: 'https://www.youtube.com/embed/jhy1Q8_7bXU?si=1nk4vWjx_Htjeg44',
    };

    const handlePlayYoutube = () => {
        setVisible(true);
        setYoutube(youtubeMap[locale] || youtubeMap.eu);
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: t('A_title'),
            position: 'rapid_series_video',
            button_name: t('A_btn'),
        });
    };

    return (
        <section id="rapid-series-A" className={`rapid-series-A ${css.section} GtmModuleData-section`} data-section-id="Rapid-Series-A">
            <div className="img">
                <EcoVideo
                    autoPlay
                    loop
                    pc="https://websiteoss.ecoflow.com/upload/video/1749463149987/pc_3C%20teaser.mp4"
                    h5="https://websiteoss.ecoflow.com/upload/video/1749463164715/m_3C%20teaser.mp4"
                    poster="https://websiteoss.ecoflow.com/upload/image/1749805277956/20250613-143355.jpeg"
                    posterH5="https://websiteoss.ecoflow.com/upload/image/1749805277937/20250613-143352.jpeg"
                />
            </div>
            <div className="info">
                {['jp'].includes(locale) && <p className="info-desc">{t('A_desc')}</p>}
                <h2 className="info-title">{t('A_title')}</h2>
                {!['jp'].includes(locale) && <p className="info-desc">{t('A_desc')}</p>}
                <button className="info-button" onClick={handlePlayYoutube}>
                    <span className="info-btn-text">{t('A_btn')}</span>
                    <svg className="info-btn-svg" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM8.7926 13.7581L13.4382 10.4054C13.7147 10.2059 13.7147 9.79413 13.4382 9.59456L8.7926 6.24188C8.46192 6.00323 8 6.23952 8 6.64733V13.3527C8 13.7605 8.46192 13.9968 8.7926 13.7581Z"
                            fill="white"
                        />
                    </svg>
                </button>
            </div>
            <EFVideoModal visible={visible} source={youtube} onClose={() => setVisible(false)} playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'} />
        </section>
    );
}
